export const jobStatusUpdateModalStyles = {
  container: {
    minHeight: '400px',
    maxHeight: '80vh',
    overflowY: 'auto',
  },

  statusSection: {
    p: 3,
    borderRadius: 2,
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    mb: 3,
  },

  section: {
    mb: 3,
  },

  sectionTitle: {
    fontWeight: 600,
    mb: 2,
    color: 'text.primary',
  },

  divider: {
    my: 3,
    borderColor: 'divider',
  },

  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 2,
    mt: 3,
    pt: 2,
    borderTop: '1px solid',
    borderColor: 'divider',
  },
};

